import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

import 'dayjs/locale/de'; // Germany
import 'dayjs/locale/en-ie'; // Ireland
import 'dayjs/locale/is'; // ICeland
import 'dayjs/locale/fr'; // France
import 'dayjs/locale/en-gb';
import { Timezone } from '../defs/Timezone';

dayjs.extend(duration);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export function setDayjsTz(tz?: Timezone) {
  const _tz = tz || 'UTC';
  dayjs.tz.setDefault(_tz);
}

export default dayjs;
